import { render, staticRenderFns } from "./RiskProfileSection.vue?vue&type=template&id=77d3b235"
import script from "./RiskProfileSection.vue?vue&type=script&lang=js"
export * from "./RiskProfileSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports